(function(){
    const excerpts = document.querySelectorAll('[data-excerpt-cutoff]');

    for ( let i = 0; i < excerpts.length; i++ ) {
        (function(container){
            const originalHtml = container.innerHTML;
            const excerptCutoff = parseInt(container.dataset.excerptCutoff);
            if ( excerptCutoff > 0 ) {
                container.innerHTML = originalHtml.substr(0, excerptCutoff).replace(new RegExp("\n", 'g'), "<br />");
                const link = document.createElement('a');
                link.classList.add('company-description__readmore');
                link.appendChild(document.createTextNode('Read more.'));
                container.appendChild(link);
                link.addEventListener('click', function(e){
                    e.preventDefault();
                    container.innerHTML = originalHtml.replace(new RegExp("\n", 'g'), "<br />");
                });
            } else {
                container.innerHTML = originalHtml.replace(new RegExp("\n", 'g'), "<br />");
            }
        })(excerpts[i]);
    }
})();